import React from 'react';
import { connect } from 'react-redux';
import { ServiceForm } from 'triider-components';

import { Creators as FormCreators } from 'store/ducks/serviceForm';

const Form = ({
  triiderUser,
  serviceId,
  tag,
  source,
  isOpen,
  isFormAddress,
  address,
  _onChange,
  onFinish,
  _closeForm,
  loadingVisible,
  selectedAddress,
}) => (
  <ServiceForm
    serviceId={serviceId}
    triiderUser={triiderUser}
    tag={tag}
    source={source}
    open={isOpen}
    isFormAddress={isFormAddress}
    address={address}
    close={_closeForm}
    onChange={_onChange}
    onFinish={onFinish}
    loadingVisible={loadingVisible}
    selectedAddress={selectedAddress}
    externalConfigAxios={{ selected_company_id: triiderUser.company && triiderUser.company.id }}
    isEnabledAddressIntegration={triiderUser.company.addresses_integration}
  />
);

const mapStateToProps = state => ({
  triiderUser: state.auth.triiderUser,
  serviceId: state.serviceForm.serviceId,
  tag: state.serviceForm.tag,
  source: state.serviceForm.source,
  isOpen: state.serviceForm.isOpen,
  isFormAddress: state.serviceForm.isFormAddress,
  address: state.serviceForm.address,
  onFinish: state.serviceForm.onFinish,
  selectedAddress: state.serviceForm.selectedAddress,
  loadingVisible: state.ui.loaders.includes('SERVICE_FORM'),
});

const mapDispatchToProps = {
  _closeForm: FormCreators.closeForm,
  _onChange: FormCreators.changeForm,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(Form);
